var _defs, _g, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoldPartnerMedallionLg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "GoldPartner-medallion",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 111.119,
    height: 157.965,
    viewBox: "0 0 111.119 157.965",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_31932",
    "data-name": "Rectangle 31932",
    width: 111.119,
    height: 157.965,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_40676",
    "data-name": "Path 40676",
    d: "M86.8,175.8a55.512,55.512,0,0,0,82.607-74.178,56.811,56.811,0,0,0-4.136-4.149L86.8,175.811Z",
    transform: "translate(-86.8 -97.47)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_40677",
    "data-name": "Path 40677",
    d: "M85.52,139.552c0,24.92,19.734,45.122,44.058,45.122s44.059-20.2,44.059-45.122S153.9,94.43,129.578,94.43s-44.058,20.2-44.058,45.122",
    transform: "translate(-85.52 -94.43)",
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Platinum_Partner_medallion_small",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15117",
    d: "M127.052,50.26,105.84,90.649h31.339L158.638,50.26H127.052Z",
    transform: "translate(-66.864 -50.26)",
    fill: "#b0b0af"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_12265",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14187",
    "data-name": "Group 14187",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12264",
    transform: "translate(0 35.164)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15118",
    d: "M147.619,77.38h-4.655a1.464,1.464,0,0,0-1.466,1.465h0v3.54a2.236,2.236,0,0,1-2.243,2.243H112.144a2.236,2.236,0,0,1-2.243-2.243h0v-3.54a1.464,1.464,0,0,0-1.465-1.465h-5.044a1.448,1.448,0,0,0-1.4,1.037L95.43,99.656h60.176l-6.561-21.238a1.475,1.475,0,0,0-1.4-1.037",
    transform: "translate(-69.952 -77.38)",
    fill: "#e9bb10"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15119",
    d: "M131.34,86.44A55.562,55.562,0,0,0,90.068,179.2l78.47-78.47a55.3,55.3,0,0,0-37.2-14.289",
    transform: "translate(-75.78 -74.693)",
    fill: "#c9971b"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12267",
    transform: "translate(14.289 61.213)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14188",
    "data-name": "Group 14188",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12266",
    transform: "translate(0 -0.013)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4149",
    width: 103.106,
    height: 103.041,
    fill: "#d5aa41"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12269",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14189",
    "data-name": "Group 14189",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12268",
    transform: "translate(10.36 57.271)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15121",
    d: "M128.969,94.43a45.122,45.122,0,1,1-45.2,45.122,45.122,45.122,0,0,1,45.2-45.122h0",
    transform: "translate(-83.77 -94.43)",
    fill: "#fdcf1f"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12271",
    transform: "translate(12.629 57.271)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14190",
    "data-name": "Group 14190",
    clipPath: "url(#clip-path-4)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12270",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4151",
    width: 88.13,
    height: 90.243,
    fill: "#e9bb10"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12273",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14191",
    "data-name": "Group 14191",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12272",
    transform: "translate(14.989 0.078)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15123",
    d: "M143.82,90.631H112.481L87.34,50.32h31.831Z",
    transform: "translate(-87.34 -50.32)",
    fill: "#57a932"
  })))))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_40678",
    "data-name": "Path 40678",
    d: "M124.832,160.963,111.27,137.481,97.72,114h54.224l-13.563,23.481-13.549,23.481Z",
    transform: "translate(-69.273 -31.355)",
    fill: "#c9971b"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_40679",
    "data-name": "Path 40679",
    d: "M124.639,158.03l-12.37-21.42L99.9,115.19h49.465L137,136.61l-12.357,21.42Z",
    transform: "translate(-68.626 -31.002)",
    fill: "#fdcf1f"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoldPartnerMedallionLg);
export default __webpack_public_path__ + "static/media/GoldPartner-medallionLg.dcb3400c3e5199f1e52b5cc510c083e7.svg";
export { ForwardRef as ReactComponent };